/**
 * infobox-tooltip
 *
 * @author    Augusto Silvino <augusto.silvino@mediatel.co.uk>
 * @copyright 2021 Mediatel Limited.
 */

"use strict";

export default function infoboxTooltip(message) {
    return `<a data-toggle="tooltip" title="${message}" href="#">
        <span style="float:right;">
            <img src="/wp-content/themes/barb_tk/images/info.png" />
        </span>
    </a>`;
};
